import { IIntegration } from './interfaces';

export const ListFeatures = [
  'Оформление заявок с доставкой на следующий день до 20:00',
  'Формирование своего графика заборов до 7 дней вперед',
  'Возможность печати ярлыков (штрих-код)',
  'Оформление заявок на забор и возврат товара',
  'Инструкции для правильного заполнения заявок',
  'Онлайн отслеживание статусов доставки',
  'Редактирование оформленных заявок в разделе «Корзина»',
  'Формирование акта приема-передачи',
  'Размещение актуальных новостей компании',
  'Просмотр истории заказов',
  'Расчет стоимости доставки',
  'Подача заявок путем загрузки .xls файла',
];

export const ListApi = [
  'Оформление заявки',
  'Запрос типов доставки',
  'Запрос статусов доставки',
  'Справочник городов',
  'Запрос списка ПВЗ',
  'Расчет стоимости доставки',
  'Справочник регионов',
  'Дополнительные утилиты',
];

export const ListBitrix = [
  'Предоставление выбора способа доставки: курьерская доставка, в пункт выдачи заказов',
  'Автоматизированный расчет стоимости доставки на уровне оформления заявки',
  'Поддержка всех возможных служб доставки: Курьерская доставка — Dalli Service, CDEK, пункты выдачи заказов — Boxberry, CDEK',
  'Отправка заказов из административной части в личном кабинете Dalli Service',
  'Список оформленных заказов в Dalli Service c возможностью ручного или автоматического обновления',
  'Интерактивная карта для удобства выбора ПВЗ на уровне оформления заявки, информационный виджет для раздела «Курьерская доставка»',
];

export const ListRetail = [
  'Предварительный расчет стоимости и сроков доставки Dalli-Service, Boxberry, CDEK с возможностью выбора ПВЗ',
  'Оформление заявок в корзину Личного Кабинета Dalli-Service с присвоением уникального кода отслеживания',
  'Автоматическое обновление информации о доставке и проставление статусов по заказам',
];

export const ListPartners: IIntegration[] = [
  {
    heightLazy: 920,
    hashId: '1c_bitrix',
    title: 'Модуль для',
    logo: require('./img/1c-bitrix.svg').default,
    heightLogo: 54,
    button: 'Маркетплейс 1С-Битрикс',
    buttonLink: 'https://marketplace.1c-bitrix.ru/solutions/dalliservicecom.delivery/',
    linkOut: true,
    description:
      'Модуль упрощает работу по передачи заказов в личный кабинет компании, представляя собой интеграцию с курьерской службой доставки Dalli-Service. Для менеджеров доступна автоматическая передача заказов в личный кабинет Dalli Service, а для покупателей — при оформлении заказа карта с виджетами точек самовывоза. Вся информация по возможным способам доставки в одном модуле. Решение поддерживает все тарифные возможности Dalli Service, а так же всех ее партнеров Boxberry, CDEK. При установке модуля на модифицированные сайты (сайты, логика работы которых отличается от коробочной логики 1С-Битрикс), как правило, требуется дополнительная настройка.',
    list: [
      'Предоставление выбора способа доставки: курьерская доставка, в пункт выдачи заказов',
      'Автоматизированный расчет стоимости доставки на уровне оформления заявки',
      'Поддержка всех возможных служб доставки: Курьерская доставка — Dalli Service, CDEK, пункты выдачи заказов — Boxberry, CDEK',
      'Отправка заказов из административной части в личном кабинете Dalli Service',
      'Список оформленных заказов в Dalli Service c возможностью ручного или автоматического обновления',
      'Интерактивная карта для удобства выбора ПВЗ на уровне оформления заявки, информационный виджет для раздела «Курьерская доставка»',
    ],
  },
  {
    heightLazy: 624,
    hashId: 'retail_crm',
    title: 'Модуль для',
    logo: require('./img/Retail-crm.svg').default,
    heightLogo: 40,
    button: 'Маркетплейс RetailCRM',
    buttonLink: 'https://www.retailcrm.ru/marketplace/dalli-service',
    linkOut: true,
    description:
      'На сегодняшний день невозможно представить хороший интернет-магазин без продвинутой CRM системы, которая автоматизирует взаимоотношения с клиентами. Одна из наиболее популярных систем подобного плана RetailCRM. Мы подготовили модуль, чтобы вы смогли удобно интегрироваться с нашей курьерской службой в «один клик».',
    list: [
      'Предварительный расчет стоимости и сроков доставки Dalli-Service, Boxberry, CDEK с возможностью выбора ПВЗ',
      'Оформление заявок в корзину Личного Кабинета Dalli-Service с присвоением уникального кода отслеживания',
      'Автоматическое обновление информации о доставке и проставление статусов по заказам',
    ],
  },
  {
    heightLazy: 713,
    hashId: 'insales',
    title: 'Приложение для',
    logo: require('./img/Insales.svg').default,
    heightLogo: 56,
    button: 'Приложение inSales',
    buttonLink: 'https://www.insales.ru/collection/apps-agregatory-sluzhb-dostavok/product/dalli',
    linkOut: true,
    description:
      'Вашему интернет-магазину на платформе InSales нужна служба доставки, кассовое обслуживание, во всех этих вопросах вам поможет Dalli. Интеграция Dalli и InSales дает не только возможность быстрой и точной передачи заявок в службу доставки.',
    list: [
      'Встраивание калькулятора стоимости доставки курьером по Москве и Московской области, с возможностью дополнительной настройки фиксированной стоимости по каждой из пяти зон',
      'Встраивание комплекта ПВЗ на ваш сайт с описанием, стоимостью, временем работы, телефонами и другой полезной информацией для вашего клиента',
      'Встраивание виджета в бэк-офис на страницы заказов, который представляет из себя форму оформления заявки Dalli, заполненную по-умолчанию данными из заказа, для последующей передачи в корзину личного кабинета Dalli',
    ],
  },
];
